import { StatusEnumItem } from './StatusEnumItem'
import { StatusEnum } from './statusEnum'

const Pending = new StatusEnumItem({
  id: 'eea01edd-de41-4231-8fb8-7bcf0908f10a',
  name: 'Pending',
  description: 'The job has been requested and is waiting to be processed',
  priority: 0,
})
const Processing = new StatusEnumItem({
  id: '5ca52faa-762a-4a2a-832e-6e005fd029d5',
  name: 'Processing',
  description: 'The job is currently processing',
  priority: 1,
})
const Completed = new StatusEnumItem({
  id: '07f7b47a-21e2-4be6-932b-0602c6590e86',
  name: 'Completed',
  description: 'The job has completed',
  priority: 2,
})
const Failed = new StatusEnumItem({
  id: '499ff0f9-5bc9-4311-97be-bcfb01fa8fa2',
  name: 'Failed',
  description: 'The job failed to complete',
  priority: 3,
})

export type JobStatusItem =
  | typeof Pending
  | typeof Processing
  | typeof Completed
  | typeof Failed

class JobStatusEnum extends StatusEnum<
  'JobStatus',
  JobStatusItem,
  JobStatusItem['name'],
  JobStatusItem['id'],
  JobStatusItem['priority']
> {
  readonly typename = 'JobStatus'
  get values() {
    return [this.Pending, this.Processing, this.Completed, this.Failed]
  }
  Pending = Pending
  Processing = Processing
  Completed = Completed
  Failed = Failed
}

/**
 * a {@link StatusEnum} for JobStatus entities
 */
export const JobStatus = new JobStatusEnum()
